// Queries de PESAJE y CURVA_ESTANDAR (M3 + ADR-029).
//
// v0.5.1 (ADR-029): la curva estándar ya no se selecciona por estirpe.
// ``useCurvaEstandar`` sigue yendo a ``/lotes-nave/{id}/curva-estandar``;
// el response ahora incluye ``origen`` y ``camadas_historico`` para que
// el frontend pinte la leyenda dinámica.

import { apiFetch, qk, useApiMutation, useApiQuery } from './client';
import type { CurvaEstandar, Pesaje, PesajeCreateInput } from '@/lib/types';

const PESAJES_KEY = qk('pesajes');

/** Lista de muestreos de un lote. */
export function usePesajesDeLote(loteId: number | null) {
  return useApiQuery<Pesaje[]>({
    queryKey: loteId != null ? [...PESAJES_KEY, 'lote', loteId] : qk('pesajes', 'lote', 'none'),
    queryFn: () => apiFetch<Pesaje[]>(`/v1/lotes-nave/${loteId}/pesajes`),
    enabled: loteId != null,
    staleTime: 30 * 1000,
  });
}

/** Curva esperada del lote de la camada: histórico si hay, si no Ajustes. */
export function useCurvaEstandar(loteId: number | null) {
  return useApiQuery<CurvaEstandar>({
    queryKey: loteId != null ? [...PESAJES_KEY, 'curva', loteId] : qk('pesajes', 'curva', 'none'),
    queryFn: () => apiFetch<CurvaEstandar>(`/v1/lotes-nave/${loteId}/curva-estandar`),
    enabled: loteId != null,
    staleTime: 60 * 1000,
  });
}

/** Crea un muestreo en un lote. */
export function useCrearPesaje() {
  return useApiMutation<{ lote_nave_id: number; body: PesajeCreateInput }, Pesaje>({
    mutationFn: ({ lote_nave_id, body }, context) =>
      apiFetch<Pesaje>(`/v1/lotes-nave/${lote_nave_id}/pesajes`, {
        offlineBase: context.offlineBase,
        method: 'POST',
        body: JSON.stringify(body),
      }),
    invalidateKeys: [['liquidacion-evolucion'], PESAJES_KEY],
  });
}

/** Edita un muestreo existente. */
export function useActualizarPesaje(loteId: number, pesajeId: number) {
  return useApiMutation<Partial<PesajeCreateInput>, Pesaje>({
    mutationFn: (body, context) =>
      apiFetch<Pesaje>(`/v1/lotes-nave/${loteId}/pesajes/${pesajeId}`, {
        offlineBase: context.offlineBase,
        method: 'PATCH',
        body: JSON.stringify(body),
      }),
    invalidateKeys: [['liquidacion-evolucion'], PESAJES_KEY],
  });
}

/** Borra un muestreo. */
export function useEliminarPesaje(loteId: number) {
  return useApiMutation<number, void>({
    mutationFn: (pesajeId, context) =>
      apiFetch<void>(`/v1/lotes-nave/${loteId}/pesajes/${pesajeId}`, {
        offlineBase: context.offlineBase,
        method: 'DELETE',
      }),
    invalidateKeys: [['liquidacion-evolucion'], PESAJES_KEY],
  });
}
